import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c3cbded")

_pushScopeId("data-v-4c3cbded")
const _hoisted_1 = {
  key: 0,
  class: "quality-box"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ( ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 수소이온 : ")
const _hoisted_6 = { id: "ph" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ph ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 화학적산소 : ")
const _hoisted_9 = { id: "cod" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" cod ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 총유기탄소량 : ")
const _hoisted_12 = { id: "toc" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" toc ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 부유물질 : ")
const _hoisted_15 = { id: "ss" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" ss ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" T-P : ")
const _hoisted_18 = { id: "tp" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" T-N : ")
const _hoisted_20 = { id: "tn" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.waterQuality!=null)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h4", null, [
            _createVNode("span", {
              id: "qualityName",
              textContent: _toDisplayString(_ctx.waterQuality.name)
            }, null, 8, ["textContent"]),
            _hoisted_3,
            _createVNode("span", {
              id: "grade",
              textContent: _toDisplayString(_ctx.waterQuality.grade)
            }, null, 8, ["textContent"]),
            _hoisted_4
          ]),
          _createVNode("ul", null, [
            _createVNode("li", null, [
              _hoisted_5,
              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.waterQuality.ph), 1),
              _hoisted_7
            ]),
            _createVNode("li", null, [
              _hoisted_8,
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.waterQuality.cod), 1),
              _hoisted_10
            ]),
            _createVNode("li", null, [
              _hoisted_11,
              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.waterQuality.toc), 1),
              _hoisted_13
            ]),
            _createVNode("li", null, [
              _hoisted_14,
              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.waterQuality.ss), 1),
              _hoisted_16
            ]),
            _createVNode("li", null, [
              _hoisted_17,
              _createVNode("span", _hoisted_18, _toDisplayString(_ctx.waterQuality.tp), 1)
            ]),
            _createVNode("li", null, [
              _hoisted_19,
              _createVNode("span", _hoisted_20, _toDisplayString(_ctx.waterQuality.tn), 1)
            ])
          ])
        ]),
        _createVNode("div", {
          class: "background",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.popupAction()))
        })
      ]))
    : _createCommentVNode("", true)
})